import i18n from "@/plugins/i18n";

export default function ({ globals }) {
	return {
		namespaced: true,
		state: {
			accountUnlocked: false,
			unableToActivateAccount: false,
			isTokenExpired: false,
			resetToken: "",
		},
		mutations: {
			SET_ACCOUNT_UNLOCKED(state, value) {
				state.accountUnlocked = value;
			},
			SET_UNABLE_TO_ACTIVATE_ACCOUNT(state, value) {
				state.unableToActivateAccount = value;
			},
			SET_IS_TOKEN_EXPIRED(state, value) {
				state.isTokenExpired = value;
			},
			SET_RESET_TOKEN(state, value) {
				state.resetToken = value ? value.replace(/\s/g, "") : value;
			},
		},
		actions: {
			async activateAccount({ state, commit, dispatch }) {
				try {
					const globalConfig = await globals.getAsyncGlobalVariable("environmentConfig");
					const confirmResponse = await fetch(`${globalConfig.backends.users}/activate-account/${state.resetToken}`, {
						method: "GET",
						headers: {
							"Content-Type": "application/json",
						},
					});

					const { result, error = null } = await confirmResponse.json();

					if (error) throw new Error(error.code);

					if (result.success) {
						commit("SET_ACCOUNT_UNLOCKED", true); return;
					}
				} catch (error) {
					const translationExists = i18n.te(`activateAccountView.errorMessages.${error.message}`);
					const code = translationExists ? error.message : "networkError";

					dispatch("logger/logError", {
						id: Date.now(),
						handled: true,
						code,
						source: "backend",
						stack: error,
						notification: i18n.t(`activateAccountView.errorMessages.${code}`),
					}, { root: true });

					if (error.message === "tokenExpiredError" || error.message === "jsonWebTokenError") {
						commit("SET_IS_TOKEN_EXPIRED", true);
						return;
					}
					commit("SET_UNABLE_TO_ACTIVATE_ACCOUNT", true);
				}
			},
		},
	};
}
